<template>
    <div class="app">
        <b-navbar toggleable="lg" type="dark" class="bgtopbar shadow-sm" fixed="top">
            <b-navbar-brand href="#">
                <b-icon icon="diamond-half"></b-icon>   {{$t('HomePage.appname')}}
            </b-navbar-brand>
            <b-col align-h="center" class="title">
                {{ $route.query.desc }} 
            </b-col>
            <b-navbar-nav class="ml-auto">
                <b-nav-item-dropdown :text="$t('LoginPage.langLabel')" right>
                    <b-dropdown-item href="#" @click.prevent="lang_en">EN</b-dropdown-item>
                    <b-dropdown-item href="#" @click.prevent="lang_la">LA</b-dropdown-item>
                </b-nav-item-dropdown>
                </b-navbar-nav>
        </b-navbar>
        
        <div class="login-page-content d-flex align-items-center justify-content-center">
            <b-container>
                <b-row class="justify-content-center">
                    <b-col md="8" lg="6" xl="5">
                        <b-card class="login-card shadow-lg border-0 rounded-lg">
                            <div class="text-center mb-4">
                                <h2 class="text-primary font-weight-bold">{{ $t('LoginPage.title') }}</h2>
                                <p class="text-muted">{{ $t('LoginPage.subtitle') }}</p>
                            </div>
                            
                            <b-form @submit.prevent="onLogin">
                                <b-form-group
                                    id="input-group-username"
                                    :label="$t('LoginPage.username')"
                                    label-for="input-username"
                                >
                                    <b-input-group class="mb-2">
                                        <b-input-group-prepend is-text>
                                            <b-icon icon="person-fill"></b-icon>
                                        </b-input-group-prepend>
                                        <b-form-input
                                            id="input-username"
                                            v-model="user.username"
                                            type="text"
                                            required
                                            :placeholder="$t('LoginPage.username')"
                                        ></b-form-input>
                                    </b-input-group>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-password"
                                    :label="$t('LoginPage.password')"
                                    label-for="input-password"
                                >
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend is-text>
                                            <b-icon icon="lock-fill"></b-icon>
                                        </b-input-group-prepend>
                                        <b-form-input
                                            id="input-password"
                                            v-model="user.password"
                                            type="password"
                                            required
                                            :placeholder="$t('LoginPage.password')"
                                        ></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                
                                <b-button type="submit" block variant="primary" class="py-2">
                                    <b-icon icon="box-arrow-in-right" class="mr-1"></b-icon>
                                    {{$t('LoginPage.btnlogin')}}
                                </b-button>
                            </b-form>

                            <b-alert
                                :show="dismissCountDown"
                                dismissible
                                fade
                                variant="danger"
                                @dismissed="dismissCountDown=0"
                                @dismiss-count-down="countDownChanged"
                                class="mt-3"
                            >
                                {{ msg }}
                            </b-alert>
                        </b-card>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    props: {},
    name: "Login",
    data() {
        return {
            dismissSecs: 5,
            dismissCountDown: 0,
            msg: "",
            showDismissibleAlert: false,
            user: {
                username: "",
                password: "",
            },
        };
    },
    mounted() {
        // Check if already logged in, redirect to home
        const login = localStorage.getItem("Login");
        if (login) {
            try {
                const userData = JSON.parse(login);
                if (userData && userData.login_hash) { // Assuming login_hash indicates a valid session
                    this.$router.replace("/");
                }
            } catch (e) {
                console.error("Failed to parse login data from localStorage", e);
                localStorage.removeItem("Login"); // Clear invalid data
            }
        }
    },
    methods: {
        lang_en() {
            this.$i18n.locale = 'en';
        },
        lang_la() {
            this.$i18n.locale = 'la';
        },
        onLogin() {
            this.dismissCountDown = 0; // Reset alert on new login attempt
            let login = [];
            let rep = null;
            let data = this.user;
            axios
                .post(this.$store.getters.getBaseUrl + "/login", data, { // Use 'headers' object for all headers
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "JWT", // This might need to be 'Bearer <token>' or a proper token
                    },
                })
                .then((response) => {
                    rep = response.data;
                    if (rep.code == 1 ) {
                        login = rep.rows[0];
                        
                        // Store login data in both sessionStorage and localStorage
                        // localStorage is generally preferred for persistent login sessions
                        // sessionStorage for session-only data (cleared when tab/browser closes)
                        // Using both might be redundant or for specific use cases.
                        // For a typical "remember me" functionality, localStorage is used.
                        // For a session-based login that clears on browser close, sessionStorage is used.
                        // Let's stick to localStorage for persistence as per original code.
                        
                        localStorage.removeItem("Login");
                        localStorage.setItem("Login", JSON.stringify(login));
                        
                        // If sessionStorage is also needed, keep it:
                        sessionStorage.removeItem("Login");
                        sessionStorage.setItem("Login", JSON.stringify(login));
                        
                        this.$store.commit("setLogin", true);
                        this.$router.replace("/"); // Use replace to prevent going back to login page
                    } else {
                        this.msg = rep.msg || this.$t('LoginPage.msgLoginFailed');
                        this.dismissCountDown = this.dismissSecs; // Show alert
                        this.$bvToast.toast(this.msg, {
                            title: `Error:`, // Changed to danger for errors
                            toaster: 'b-toaster-top-right',
                            solid: true,
                            variant: 'danger',
                            appendToast: true
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.msg = this.$t('LoginPage.msgErrorDefault'); // Generic error message for user
                    if (err.response && err.response.data && err.response.data.msg) {
                        this.msg = err.response.data.msg; // Use specific error from backend if available
                    }
                    this.dismissCountDown = this.dismissSecs; // Show alert
                    this.$bvToast.toast(this.msg, {
                        title: `Error:`,
                        toaster: 'b-toaster-top-right',
                        solid: true,
                        variant: 'danger', // Changed to danger for errors
                        appendToast: true
                    });
                });
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
    },
};
</script>

<style scoped>
/* General app styling */
.app {
  min-height: 100vh; /* Ensure app takes full height */
  display: flex;
  flex-direction: column;
  font-family: 'Noto Sans Lao', sans-serif;
}

/* Top navigation bar styling */
.bgtopbar {
  background-color: #4e73df !important; /* A common primary blue */
}

/* Main login page content area */
.login-page-content {
  flex-grow: 1; /* Allows it to take remaining height */
  background: linear-gradient(to right, #4e73df, #224abe); /* Subtle gradient background */
  /* Alternative: background image */
  /* background-image: url('https://via.placeholder.com/1920x1080/4e73df/ffffff?text=Background+Image'); */
  /* background-size: cover; */
  /* background-position: center; */
  /* background-repeat: no-repeat; */
  padding-top: 80px; /* To account for fixed navbar */
  padding-bottom: 20px;
}

/* Login card styling */
.login-card {
  background-color: #ffffff; /* White card background */
  padding: 30px;
  border-radius: 15px; /* More rounded corners */
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important; /* Stronger shadow */
}

/* Card title styling */
.login-card h2 {
  font-size: 1.8rem; /* Larger title */
  font-weight: 700;
  color: #4e73df; /* Primary color for title */
  margin-bottom: 0.5rem;
}

/* Input group styling */
.input-group-prepend {
  background-color: #e9ecef; /* Light gray background for icon */
  border-right: 1px solid #ced4da;
}
.input-group-prepend .b-icon {
  color: #6c757d; /* Icon color */
}

/* Button styling */
.btn-primary {
  background-color: #4e73df !important;
  border-color: #4e73df !important;
  font-weight: bold;
}
.btn-primary:hover {
  background-color: #224abe !important; /* Darker shade on hover */
  border-color: #224abe !important;
}

/* General text styling */
.text-primary {
  color: #4e73df !important;
}
.text-muted {
  color: #6c757d !important;
}

/* Alert styling for error messages */
.alert-danger {
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}

/* Ensure form-group labels are visible */
.b-form-group label {
  font-weight: 600;
  color: #343a40;
}
</style>
